import './App.css';
import i18n from './libs/i18n'; /* eslint-disable-line no-unused-vars */
import { useTranslation } from 'react-i18next';
import Language from './Views/Language';
import Game from './Views/Game';
import FeedbackCorrect from './Views/FeedbackCorrect';
import FeedbackWrong from './Views/FeedbackWrong';
import FeedbackAnswer from './Views/FeedbackAnswer';
import { Routes, Route } from "react-router";
import Question from './Views/Question';

export function App() {

	// define variables
	const location = "gnt"; // bxl, lie, ant, gnt

    // change language
    i18n.changeLanguage('nl');

	// define functions
	let timer;
	const inactivityTime = (30 * 1000);
	const setInactivityTimer = () => {

		clearTimeout(timer);
		timer = setTimeout(function() { window.location.reload(); }, inactivityTime);

	};

	const clearInactivityTimer = () => {

		clearTimeout(timer);

	};

	// render html
	return (
		<Routes>
			<Route path="/" element={<Language inactivity={clearInactivityTimer} location={location} />} />
			<Route path="/:location/:locale/question" element={<Question inactivity={setInactivityTimer} location={location} />} />
			<Route path="/:location/:locale" element={<Game inactivity={setInactivityTimer} location={location} />} />
			<Route path="/:location/:locale/correct" element={<FeedbackCorrect inactivity={setInactivityTimer} location={location} />} />
			<Route path="/:location/:locale/wrong" element={<FeedbackWrong inactivity={setInactivityTimer} location={location} />} />
			<Route path="/:location/:locale/answer" element={<FeedbackAnswer inactivity={setInactivityTimer} location={location} />} />
		</Routes>
	);
}
